const version = "2.1"

export {version}